import { isAxiosError } from "axios";
import { useRouteError } from "react-router-dom";

import { ShareErrorState } from "./ShareErrorState";

/**
 * Error boundary component for share routes that inspects the error
 * and displays the appropriate error state based on the error type.
 */
export const ShareRouteErrorBoundary = () => {
  const error = useRouteError();

  if (isAxiosError(error)) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      return <ShareErrorState errorType="invalid-token" />;
    }

    if (status === 404) {
      return <ShareErrorState errorType="not-found" />;
    }
  }

  return <ShareErrorState errorType="network-error" />;
};
